import React, {useState} from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import AccountDialog from "../account/account_dialog";

const AccountDropDown = () => {

  const [menu, setMenu] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(0);
  const [accounts, setAccounts] = useState([
    { name: "Прокрафт Дизайн Агентлаг" },
    { name: "Прокрафт Дизайн" },
  ]);

  const changeAccount = (e, i) => {
    e.preventDefault();
    setSelectedAccount(i);
  };

  const [open, setOpen] = useState(false);
  const toggle = (value) => setOpen(value);

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={() => setMenu(!menu)}>
        <DropdownToggle className="d-flex align-items-center pointer" tag="div">
          <div className="orga_dropdown bordered mx-2">
            <img alt="logo" src="/images/orga_logo.svg" height={20} />
          </div>
          <img alt="drop" src="/images/arrow_down.svg" height={8} />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu">
          <DropdownItem tag="div">
            <div className="text-grey font-size-12 ">
              Нэвтэрсэн хаягууд
            </div>
          </DropdownItem>
          {accounts.map((a, i) => (
            <DropdownItem
              tag="div"
              key={`account-${i}`}
              onClick={(e) => changeAccount(e, i)}
              className="dropdown-item d-flex align-items-center py-1 pointer"
            >
              <div className="orga_dropdown bordered ms-2">
                <img alt="logo" src="/images/orga_logo.svg" height={20} />
              </div>
              <div className="font-size-15">{a.name}</div>
              <div
                style={{ minWidth: "45px" }}
                className="flex-grow-1 text-end"
              >
                <img
                  alt="checked"
                  className={`${i === selectedAccount ? "d-inline-block" : "d-none"}`}
                  src="/images/check.svg"
                  height={13}
                />
              </div>
            </DropdownItem>
          ))}
          <div className="divider my-1"></div>
          <DropdownItem
            tag="a"
            href="#"
            className="mt-1 d-flex align-items-center font-size-14"
            onClick={() => toggle(true)}
          >
            <img
              alt="add"
              src="/images/add.svg"
              height={10}
              width={10}
              className="ms-3"
            />
            Хаяг нэмэх
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <AccountDialog
        open={open} 
        toggle={toggle}
      />
    </React.Fragment>
  );
};

export default AccountDropDown;
